import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from '../app.service';
import { LoaderService } from '../loader/loader.service';

@Component({
  templateUrl: './quizz.component.html',
  styleUrls: ['./quizz.component.css'],
  providers: [AppService, LoaderService]
})
export class QuizzComponent implements OnInit {
  nbQuiz: number;
  answers = [];
  error: String;

  constructor(
  private appService: AppService,
  private loaderService: LoaderService
  ) {}

  ngOnInit() {}

  onSubmitCount(nb: NgForm) {
    if(!nb.value.count) {
      alert('Vous ne pouvez pas laisser de champ(s) vide(s)')
    } else {
      const count = nb.value.count;
      if(count < 2 || count > 10) {
        alert('Le nombre de propositions doit être compris entre 2 et 10');
        return
      }
      this.answers = new Array(count).fill(Math.round(100 / count));
    }
  }

  onSubmitAnswers(pr) {
    this.error = '';
    this.loaderService.show();
    const percents = (<any>Object).values(pr.value);
    this.appService.sendQuizz({
      messagesNumber: percents
    })
    .subscribe((res) => {
      console.log("res:", res);
      this.loaderService.hide();
    }, (err) => {
      this.loaderService.hide();
      this.error = err;
    });
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }
}



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/quizz/quizz.component.ts